export default "/assets/images/crittercuddler-circle.png?2eb4cb2ac0932f8fd5d6564c9d4626c0";